import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';

const EventDate = ({ date, ...rest }) => {
  const isLoading = !date;

  return (
    <Box sx={{ textAlign: 'center', width: '100%' }} {...rest}>
      <Typography sx={{ textTransform: 'uppercase' }}>{isLoading ? <Skeleton /> : date.format('MMM')}</Typography>
      <Typography sx={{ fontSize: '1.5rem', fontWeight: 300 }}>
        {isLoading ? <Skeleton /> : date.format('DD')}
      </Typography>
    </Box>
  );
};

export default EventDate;
